import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TracItEditActionPopupComponent } from '../edit-action-popup/edit-action-popup.component';
import { ActionItemService } from 'src/Services/tracit.service';
import { ActionItemSearchModel } from 'src/Models/TracItModel';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-tracit-action-item-details',
  templateUrl: './action-item-details.component.html',
  styleUrls: ['./action-item-details.component.css']
})
export class TracItActionItemDetailsComponent implements OnInit {
  @Input() actionItem = new ActionItemSearchModel();
  @Input() stateArray: any = [];
  @Input() carrierCategoryArray: any = [];
  @Input() isAccordianShow: any = [];
  @Output('editItemReload') editItemReload = new EventEmitter();
  @Output('deleteItemReload') deleteItemReload = new EventEmitter();
  displayState: string;
  tokenKey = '';
  isShowprogressSpinner: boolean;
  blockedDocument: boolean;
  isHoverButtonClick: boolean = false;
  productId: number = 0;
  actionId: number = 0;
  userId = 0;
  isAccess = false;

  constructor(private readonly actionService: ActionItemService,
    private readonly toastr: ToastrService,
    private readonly modalService: NgbModal,
    private sessionStorageService: SessionStorageService) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.productId =4;
    this.userId = +sessionStorage.getItem('UserId');
  }

  ngOnInit() {
    if (sessionStorage.getItem('CompanyName').includes('FAStek') || sessionStorage.getItem('CompanyName').includes('Inteserra')) {
      this.isAccess = true;//sessionStorage.setItem('CompanyName', this.userModel.companyName);
    }
    else {
      this.isAccess = false;
    }
  }

  downloadocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
    this.actionService.DownloadDocument(this.tokenKey, { DocType: 'BriefingDoc', DocPath: this.actionItem.briefingDocPath }).subscribe(
      fileData => {
        this.isShowprogressSpinner = false;
        this.blockedDocument = false;
        if (fileData != null) {
          FileSaver.saveAs(fileData, this.actionItem.displayBriefingDocName);
          this.toastr.success('File Downloaded.');
        }
      }, error => {
        this.isShowprogressSpinner = false;
        this.blockedDocument = false;
        console.log(error);
      });
  }

  showListPopupHover() {
    this.isHoverButtonClick = false;
    if (+this.actionItem.actionItemTypeId == 5) {
      this.actionId = +this.actionItem.actionId;
      this.editAction(this.actionId)
      this.isHoverButtonClick = true;
    }
  }

  editAction(actionId) {
    sessionStorage.setItem('EditActionId', actionId);
    sessionStorage.setItem('productId', this.productId.toString());
    const modalRef = this.modalService.open(TracItEditActionPopupComponent, { windowClass: "EditActionPopup" }).result.then(
      result => {
        if (result == 'Yes') {
          this.isHoverButtonClick = false;
          this.editItemReload.emit();
        }
      },
      reason => {
        this.isHoverButtonClick = false;
      });
  }

  DeleteRecord(type) {
    const actionid = type == 1 ? this.actionItem.actionId : 0;
    const recurranceId = type == 2 ? this.actionItem.recurranceId : 0;
    this.actionService.DeleteAction(actionid, recurranceId, this.userId).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.toastr.success('Record deleted successfully.', 'Success');
          this.deleteItemReload.emit();
        }
        this.isHoverButtonClick = false;
      },
      error => {
        this.isHoverButtonClick = false;
        this.toastr.error(error, 'Error');
      }
    );
  }

}
